import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as auth from './modules/auth'
import * as user from './modules/user'
import * as cashierDesk from './modules/cashierDesk'
import * as right from './modules/right'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    user,
    cashierDesk,
    right
  },
  state: () => ({}),
  mutations: {},
  plugins: [createPersistedState()]
})

export default store
